import type { CardPaymentMode, CurrencyCode } from "@shared/contracts";

export type ManualCardPaymentRequest = {
  amountMinor: number;
  currency: CurrencyCode;
  operatorConfirmed: boolean;
  reference?: string;
};

export type ManualCardPaymentConfirmation = {
  mode: CardPaymentMode;
  status: "confirmed";
  amountMinor: number;
  currency: CurrencyCode;
  confirmedAt: string;
  reference?: string;
};

export class ManualCardPaymentAdapter {
  confirm(input: ManualCardPaymentRequest): ManualCardPaymentConfirmation {
    if (!Number.isSafeInteger(input.amountMinor) || input.amountMinor <= 0) throw new Error("Card amount must be a positive integer minor unit");
    if (!input.operatorConfirmed) throw new Error("Operator must confirm the external card terminal result");
    const reference = input.reference?.trim() || undefined;
    return {
      mode: "manual",
      status: "confirmed",
      amountMinor: input.amountMinor,
      currency: input.currency,
      confirmedAt: new Date().toISOString(),
      reference,
    };
  }
}
